export const COLUMN_WIDTH = 750;
